import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

import KogInputAutoCompleteCheckControlled from "@/main/components/shared/inputAutoCompleteCheck/inputAutoCompleteCheckControlled";
import { isNullUndefined } from "@/main/services/utils";

import { GeneralVariableType, useDynamicFiltersExport } from "./dynamicFiltersExport";
import { getCountriesUser, useCountryReducer } from "@/main/store/country";

interface IVariableTypeCountryProps extends GeneralVariableType {}
function VariableTypeCountry({ filter }: IVariableTypeCountryProps) {
	const dispatch = useDispatch();
	const { findFieldIndexByGuidDynamicReportVariable, idScreen, watcherCountry } = useDynamicFiltersExport();
	const { countriesUser: countryReducer } = useCountryReducer();
	const { control } = useFormContext();

	useEffect(() => {
		if (isNullUndefined(countryReducer)) dispatch(getCountriesUser());
	}, [JSON.stringify(watcherCountry?.key)]);

	const disabledCountry = isNullUndefined(countryReducer.data) || countryReducer.data.length === 0;
	const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

	return (
		<>
			<KogInputAutoCompleteCheckControlled
				name={`filtersDinamics.${indexField}.value`}
				disableSelectAll
				control={control}
				options={countryReducer.data || []}
				label={filter.responseServer.filterName}
				disabled={disabledCountry}
				isLoading={countryReducer.isLoading}
				controllerProps={{
					rules: { required: filter.responseServer.mandatory },
				}}
				customInputProps={{
					required: filter.responseServer.mandatory,
					id: idScreen("select-countries"),
				}}
				onChangeCustom={() => {}}
			/>
		</>
	);
}

export default VariableTypeCountry;
